import { Component, Input, EventEmitter, Output, ViewEncapsulation } from '@angular/core';
import {
  CardSizes,
  CardColors,
  CardButton,
  CardIcon,
} from '@app/theme/card/card.interfaces';

import { environment } from '@environments/environment';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CardComponent {
  @Input() title: string;

  @Input() subTitle: string;

  @Input() subTitle1: string;

  @Input() subTitle2: string;

  @Input() subTitle3: string;

  @Input() noGutters = false;

  @Input() enableLeftBorder = false;

  @Input() disableHeaderDivider = false;

  @Input() size: CardSizes = 'default';

  @Input() color: CardColors = 'default';

  @Input() button: CardButton;

  @Input() icon: CardIcon;

  @Input() equalizer: boolean = false;

  @Input() isViewVersion: boolean = false;

  @Output() buttonClick = new EventEmitter<void>();

  versionPortal: string = environment.version;

  handleButtonClick() {
    this.buttonClick.emit();
  }
}
